<template>
  <v-card
    class="d-flex flex-column align-center main-card"
    flat
    tile
    :height="isMobileBreakpoint ? '100vh' : '637'"
  >
    <div
      class="w-full d-flex px-3 pt-6"
      :class="{
        'justify-end': uploadItems,
        'justify-space-between': !uploadItems,
      }"
    >
      <div class="d-flex" v-if="!uploadItems">
        <v-btn icon @click="handleBackInitialScreen">
          <v-icon
            class="close-icon"
            size="24"
            color="grey"
            style="cursor: pointer"
          >
            mdi-arrow-left
          </v-icon>
        </v-btn>
        <div class="d-flex flex-column">
          <span class="body-bold-small">{{
            isSubtitle
              ? $t('message.ai.subtitles.uploadModal.title')
              : $t('message.ai.dubbings.uploadModal.title')
          }}</span>
          <span class="body-regular-smaller neutral-40-light--text">
            {{
              isSubtitle
                ? $t('message.ai.subtitles.uploadModal.description')
                : $t('message.ai.dubbings.uploadModal.description')
            }}
            <a
              target="_blank"
              type="secondary"
              size="xsmall"
              :href="
                isSubtitle
                  ? $t('message.ai.subtitles.uploadModal.href')
                  : $t('message.ai.dubbings.uploadModal.href')
              "
            >
              {{ $t('message.embedModal.knowMoreInArticle') }}

              <v-icon size="12">mdi-open-in-new</v-icon>
            </a>
          </span>
        </div>
      </div>
      <v-btn icon @click="handleClose">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="container-title px-2">
      <base-drop-zone
        v-if="!uploadItems"
        @file-uploaded="handleFileInput"
        :heightCard="toBeUploadedList.length ? '240' : '100%'"
        :heightDropzone="toBeUploadedList.length ? '165' : '500'"
        :typeFile="accept.toString().replace(', ', ',')"
        :styleDropzone="styleDropzone"
        :styleIcon="styleIcon"
        :textTitleType="
          isSubtitle
            ? $t('message.ai.subtitles.uploadModal.dropZoneTitle')
            : $t('message.ai.dubbings.uploadModal.dropZoneTitle')
        "
        :textSubTitleType="
          isSubtitle
            ? $t('message.ai.subtitles.uploadModal.dropZoneDescription')
            : $t('message.ai.dubbings.uploadModal.dropZoneDescription')
        "
      />
      <div
        v-else
        style="
          width: 100%;
          display: flex;
          gap: 16px;
          padding-top: 50px;
          padding-bottom: 50px;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        "
      >
        <v-progress-circular
          v-if="!allItemsUploaded && !itemWithError"
          indeterminate
          color="brand"
        />
        <v-icon size="66" color="#4CAF50" v-if="allItemsUploaded"
          >panda-check-round</v-icon
        >
        <v-icon size="66" color="#F44336" v-if="itemWithError">
          mdi-close-octagon
        </v-icon>
        <span class="body-bold-medium">
          {{ $t(statusMessage) }}
        </span>
      </div>
    </div>

    <div
      style="
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
        overflow: auto;
        padding-left: 24px;
        padding-right: 24px;
      "
      v-if="toBeUploadedList.length"
    >
      <div
        class="d-flex align-center justify-space-between py-6 pl-2 pr-4"
        v-for="(item, index) in toBeUploadedList"
        :key="`${item.label}--${index}`"
        :class="{ 'border-top': index > 0, 'pt-0': index == 0 }"
      >
        <span
          class="body-regular-small d-flex align-center"
          style="max-width: 40%"
        >
          <img
            v-if="uploadItems"
            width="16"
            class="mr-2"
            style="flex-shrink: 0"
            :src="currentIcon(item.label, true)"
          />
          <span
            style="
              display: inline-block;
              max-width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              vertical-align: middle;
            "
            >{{ item.file.name }}</span
          >
        </span>
        <div
          style="width: 50%; display: flex; justify-content: flex-end; gap: 8px"
        >
          <v-select
            v-if="!uploadItems"
            v-model="item.label"
            :items="unusedLangCodes"
            append-icon="mdi-chevron-down"
            item-text="label"
            hide-details
            item-value="label"
            placeholder="Selecione"
            :error="isLanguageAlreadySelected(item.label, index)"
            :menu-props="{ top: false, offsetY: true }"
            outlined
            @change="handleUpdateSrcLang(index)"
          >
            <template
              #prepend-inner
              v-if="item.label && !isLanguageAlreadySelected(item.label, index)"
            >
              <img
                width="16"
                class="mt-1 mr-2"
                :src="currentIcon(item.label, true)"
              />
            </template>
          </v-select>
          <v-btn
            v-if="!uploadItems"
            icon
            @click="removeFromToBeUploadedList(index)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-tag v-if="itemWithError" type="error">
            {{ 'Erro' }}
          </v-tag>
          <v-tag v-else-if="itemStatus(item) === 'pending'">{{
            $t('message.ai.queue')
          }}</v-tag>

          <v-tag
            v-else-if="
              itemStatus(item) === 'uploading' && item.progress.percentage
            "
            type="default"
          >
            {{ item.progress.percentage }}%
          </v-tag>
          <v-progress-circular
            v-if="itemStatus(item) === 'uploading' && !itemWithError"
            :value="item.progress.percentage"
            color="brand"
            size="16"
          />

          <template v-if="itemStatus(item) === 'uploaded'">
            <v-tag type="success">{{ $t('message.sent') }}</v-tag>
            <v-icon size="16" color="#4CAF50">panda-check-round</v-icon>
          </template>
        </div>
      </div>
    </div>
    <unsaved-changes-modal />
    <div class="container-actions" v-if="toBeUploadedList.length">
      <base-btn type="tertiary" @click="handleClose" v-if="!uploadItems">
        {{ $t('message.actions.cancel') }}</base-btn
      >
      <base-btn
        @click="handlePostNewSubtitles"
        v-if="!uploadItems && type == 'Subtitle'"
        :disabled="hasSelectError"
      >
        {{ $t('message.continue') }}</base-btn
      >
      <base-btn
        @click="handlePostDubbing"
        v-else-if="!uploadItems && type == 'Dubbing'"
        :disabled="hasSelectError"
      >
        {{ $t('message.continue') }}</base-btn
      >
      <base-btn
        @click="handleClose"
        :disabled="!allItemsUploaded"
        :loading="!allItemsUploaded"
        v-else
      >
        {{ $t('message.pages.warningPaymentIssues.finish') }}</base-btn
      >
    </div>
  </v-card>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import BaseDropZone from './BaseDropZone.vue'
import i18n from '@/translations/lang'
import langCodesMixin from '@/utils/langCodes.mixin.js'
import aiWorkflowMixin from '@/utils/aiWorkflow.mixin'
import videosApi from '@/services/videosApi'
import UnsavedChangesModal from '@/components/UnsavedChangesModal.vue'
export default {
  components: { BaseDropZone, UnsavedChangesModal },
  name: 'ScreenInitialDubSubTemplate',
  props: {
    type: {
      type: String,
      required: true,
    },
    accept: {
      type: Array,
      default: () => ['.vtt', '.srt'],
    },
    unusedLangCodes: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [langCodesMixin, aiWorkflowMixin],
  data: () => ({
    loading: false,
    errors: [],
    error: false,
    videoId: '',
    uploadSubtitles: [],
    uploadItems: false,
    uploadSubtitlesWithError: [],
  }),
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
      subtitleUploadData: (state) => state.video.subtitleData.upload,
      dubbingUploadData: (state) => state.video.dubbingData.upload,
    }),
    statusMessage() {
      const basePath =
        this.type === 'Dubbing' ? 'message.ai.dubbings' : 'message.ai.subtitles'

      if (this.itemWithError) return `${basePath}.error${this.type}`
      if (this.allItemsUploaded) return `${basePath}.success${this.type}`
      return `${basePath}.sending${this.type}`
    },
    styleDropzone() {
      if (!this.toBeUploadedList.length)
        return {
          alignItems: 'center !important',
        }
      return {
        width: '100%',
        flexDirection: 'column',
        padding: '24px',
        justifyContent: 'space-between',
        textAlign: 'start',
        alignItems: 'center !important',
      }
    },
    styleIcon() {
      if (!this.toBeUploadedList.length) return {}
      return {
        padding: '8px !important',
        marginBottom: '0px !important',
        fontSize: '24px',
      }
    },
    isSubtitle() {
      return this.type == 'Subtitle'
    },
    allItemsUploaded() {
      return this.toBeUploadedList.every(
        (item) => item.uploaded === true || item.progress?.uploadComplete
      )
    },
    itemWithError() {
      return this.toBeUploadedList.every((item) => item.error === true)
    },
    hasSelectError() {
      const labels = this.toBeUploadedList
        .map((item) => item.label)
        .filter(Boolean)
      const uniqueLabels = new Set(labels)
      return uniqueLabels.size !== labels.length
    },
    toBeUploadedList() {
      let list = this.subtitleUploadData.subtitleListToBeUploaded

      if (!this.isSubtitle)
        list = this.dubbingUploadData.dubbingListToBeUploaded
      return list
    },
  },
  methods: {
    ...mapMutations('video', [
      'UPDATE_VIDEO',
      'UPDATE_GENERATING_SUBTITLE_DATA',
      'UPDATE_VIDEO_SUBTITLES',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    itemStatus(item) {
      const objProgress = item?.progress
      if (
        objProgress &&
        objProgress.bytesUploaded &&
        !objProgress.uploadComplete
      )
        return 'uploading'
      if (item?.uploaded || (objProgress && objProgress.uploadComplete))
        return 'uploaded'
      if (this.uploadItems) return 'pending'
    },
    isLanguageAlreadySelected(language, currentIndex) {
      if (!language) return false
      return this.toBeUploadedList.some(
        (item, index) => item.label === language && index !== currentIndex
      )
    },
    currentIcon(language, isLabel) {
      if (isLabel)
        language = this.langCodes.filter(({ label }) => label === language)[0]
          .srclang
      const lang = language == 'pt-BR' ? 'pt' : language
      const country = this.getCountryCodeBySrcLang(lang)
      const selectedItem = this.flagMap[country]
      return selectedItem ? selectedItem : require('@/assets/brazil.svg')
    },
    clearErrors() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
    },
    handleBackInitialScreen() {
      this.$root.$emit(`back${this.type}InitialScreen`)
    },
    handleClose(type, forceClose) {
      if (this.uploadItems && !this.allItemsUploaded && !forceClose) {
        this.$root.$emit(
          'unsavedChangesModal',
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          true
        )
        return
      }
      this.subtitleUploadData.subtitleListToBeUploaded = []
      this.dubbingUploadData.dubbingListToBeUploaded = []
      this.uploadItems = false
      this.$root.$emit(`close${this.type}Modal`)
    },
    handleUpdateSrcLang(index) {
      let target = this.subtitleUploadData.subtitleListToBeUploaded[index]
      if (!this.isSubtitle)
        target = this.dubbingUploadData.dubbingListToBeUploaded[index]

      const srclang = this.langCodes.find(
        ({ label }) => label === target?.label || label === target
      )
      target.srclang = srclang.srclang
    },
    removeFromToBeUploadedList(index) {
      let spliceList = this.subtitleUploadData.subtitleListToBeUploaded

      if (!this.isSubtitle) {
        spliceList = this.dubbingUploadData.dubbingListToBeUploaded
      }

      spliceList.splice(index, 1)
    },
    handleFileInput(file) {
      if (!(file instanceof File)) return
      const isOver1GB = file.size > 1024 * 1024 * 1024
      const isOver10MB = file.size > 10 * 1024 * 1024
      if (
        (isOver1GB && this.type === 'Dubbing') ||
        (this.isSubtitle && isOver10MB)
      ) {
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: i18n.t('message.ai.sizeNotAllowed'),
          type: 'error',
        })
        return
      }
      this.clearErrors()
      let fileExtension =
        file?.name?.substring(
          file?.name?.lastIndexOf('.'),
          file?.name?.length
        ) || file?.name
      if (!this.accept.includes(fileExtension)) {
        this.errors.wrongFormatFile = true
        this.subtitleUploadData.subtitleToBeUploaded = null
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: this.isSubtitle
            ? i18n.t('message.ai.formatNotAllowed')
            : i18n.t('message.ai.formatNotAllowedDubbing'),
          type: 'error',
        })
        return
      }
      this.subtitleUploadData.subtitleToBeUploaded = file
      if (!this.isSubtitle) this.dubbingUploadData.dubbingToBeUploaded = file
      const handleFinishFileInput = {
        Subtitle: this.handleInputSubtitle,
        Dubbing: this.handleInputDubbing,
      }
      handleFinishFileInput[this.type]()
    },
    handleSelectMode() {
      this.$root.$emit(`back${this.type}Modal`)
    },
    handleInputSubtitle() {
      this.subtitleUploadData.subtitleListToBeUploaded.push({
        file: this.subtitleUploadData.subtitleToBeUploaded,
        srclang: this.unusedLangCodes[0].srclang,
        label: this.unusedLangCodes[0].label,
      })
      this.subtitleUploadData.subtitleToBeUploaded = null
    },
    handleInputDubbing() {
      this.dubbingUploadData.dubbingListToBeUploaded.push({
        file: this.dubbingUploadData.dubbingToBeUploaded,
        srclang: this.unusedLangCodes[0].srclang,
        label: this.unusedLangCodes[0].label,
      })
      this.dubbingUploadData.dubbingToBeUploaded = null
    },
    async handlePostNewSubtitles() {
      this.uploadItems = true
      for (const [
        index,
        item,
      ] of this.subtitleUploadData.subtitleListToBeUploaded.entries()) {
        item.pending = true
        await this.handleAddSubtitle(item, index)
      }
    },
    handlePostDubbing() {
      this.dubbingUploadData.dubbingListToBeUploaded.map((item) => {
        this.$root.$emit('addAudio', {
          ...item,
          ...{ video_id: this.videoId },
        })
      })
      this.uploadItems = true
    },
    async handleAddSubtitle(subtitle) {
      this.clearErrors()
      const data = new FormData()
      const langCode = this.langCodes.filter((lang) => {
        return lang.label === subtitle.label
      })
      subtitle.srclang = langCode[0].srclang
      data.append('file', subtitle.file)
      data.append('label', subtitle.label)
      data.append('srclang', subtitle.srclang)
      try {
        const response = await videosApi.addSubtitleToVideo(this.videoId, data)
        const subtitles = this.$store.state.video.video.config?.subtitles || []
        subtitles.push({
          label: subtitle.label,
          srclang: subtitle.srclang,
        })
        const videoConfig = await window.db.videos
          .where({ id: this.videoId })
          .first()
        this.$set(subtitle, 'pending', false)
        this.$set(subtitle, 'uploaded', response.status === 200)
        this.$set(subtitle, 'error', response.status !== 200)
        videoConfig.subtitles = subtitles
        await window.db.videos.update(this.videoId, videoConfig)

        this.UPDATE_VIDEO_SUBTITLES(subtitles)
        this.$root.$emit('updateVideoSubtitles', subtitles)
      } catch (e) {
        console.error(e)
      }
    },
  },
  beforeDestroy() {
    this.loading = false
  },
  mounted() {
    this.videoId = this.$route.params.id
    this.loading = false
    this.$root.$on('handleUploadItems', () => {
      this.handleClose('boolean', true)
    })
  },
}
</script>
<style lang="scss" scoped>
.container-title {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.main-card {
  height: 637px;
}
.w-full {
  width: 100%;
}
.container-card-options {
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 8px;
  background: varFigma(neutral-99);
}
.container-actions {
  border-top: 1px solid varFigma(neutral-95-lightest);
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding: 24px;
}
.border-top {
  border-top: 1px solid varFigma(neutral-95-lightest);
}
@media screen and (max-height: 700px) {
  .main-card {
    height: 85vh !important;
  }
}
</style>
